import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import type { Project } from '../types/api';

export const adminProjectsKeys = {
  all: ['admin-projects'] as const,
  list: (filters: AdminProjectsFilters) => [...adminProjectsKeys.all, 'list', filters] as const,
};

export interface AdminProjectsFilters {
  q?: string | undefined;
  status?: 'active' | 'archived' | 'closed' | undefined;
  include_deleted?: boolean | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
}

export function useAdminProjectsList(filters: AdminProjectsFilters = {}) {
  return useQuery({
    queryKey: adminProjectsKeys.list(filters),
    queryFn: async () => {
      const res = await api.get<{ projects: Project[]; total: number }>('/admin/projects', {
        ...filters,
      });
      return res;
    },
  });
}
